import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import BottomNavigation from './BottomNavigation';
import { motion } from 'framer-motion';
import { isNativeUi } from '../../utils/nativeUi';

const AUTH_PATH = /^\/auth/;

const Layout: React.FC = () => {
  const location = useLocation();
  const showMobileBottomNav = !AUTH_PATH.test(location.pathname);
  const hideHeaderOnNativeAuth = isNativeUi() && AUTH_PATH.test(location.pathname);

  return (
    <div
      className={`fixnow-app-shell flex flex-col min-h-dvh min-h-screen ${
        hideHeaderOnNativeAuth ? 'fixnow-shell-auth-native bg-[#f4f6fb]' : 'bg-gray-50'
      }`}
    >
      {!hideHeaderOnNativeAuth && <Header />}
      <main
        className={`flex flex-grow flex-col ${showMobileBottomNav ? 'fixnow-main-with-bottom-nav md:pb-0' : ''}`}
      >
        <motion.div
          key={location.pathname}
          className={hideHeaderOnNativeAuth ? 'flex min-h-0 flex-1 flex-col' : undefined}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <Outlet />
        </motion.div>
      </main>
      <Footer />
      <BottomNavigation />
    </div>
  );
};

export default Layout;
